import type { UserCourseTemplate } from "api/schemas/UserCourse";
import type { TreatmentSchedulesItem } from "api/services/treatment/schemas/Treatment";

export const filterTemplates = (group: string) => (item: UserCourseTemplate) => {
  switch (group) {
    case "all":
      return true;
    case "custom":
      return !item.standardized;
    case "standardized":
      return item.standardized;
    default:
      return item.group === group;
  }
};

export const filterTreatmentSchedule =
  (group: string) =>
  ({ creator_id, group: itemGroup }: TreatmentSchedulesItem) => {
    switch (group) {
      case "all":
        return true;
      case "custom":
        return creator_id !== null;
      case "standardized":
        return creator_id === null;
      default:
        return itemGroup === group;
    }
  };

export const searchTemplate =
  (search: string) =>
  <T extends { name: string }>(template: T) => {
    if (template.name && template.name.toLowerCase().includes(search.toLowerCase())) {
      return template;
    }
    return undefined;
  };
